import { NotificationSlice } from "./visitsSlice"


export const notificationReducer = NotificationSlice.reducer
export const notificationActions = NotificationSlice.actions
